import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent implements OnInit {
  buttonsText = {
    buttonAcceptText: 'Aceptar',
    buttonRejectText: 'Cancelar'
  }
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string, buttonAcceptText?: string},
    private dialogRef: MatDialogRef<NotificationDialogComponent>
  ) { }

  ngOnInit(): void {
    this.buttonsText.buttonAcceptText = this.data.buttonAcceptText ? this.data.buttonAcceptText : 'Aceptar';
  }

  closeAction(type: boolean): void {
    this.dialogRef.close(type);
  }
}
